import classNames from 'classnames';

export default function DataItem({
  label,
  value,
  containerClassName = 'my-0 pr-[8px] md:pr-auto',
  labelClassName = '',
  valueClassName = '',
  defaultValue = '-',
  isSmall = false,
  isHalf = false,
  isVisible = true,
  lastItem = false,
}) {
  if (!isVisible || !value) {
    return null;
  }

  return (
    <div
      className={classNames(
        `${containerClassName} text-[16px] break-words`,
        {
          'w-56': !isSmall && !isHalf,
        },
        {
          'w-[50%] lg:w-[33%]': isSmall && !isHalf,
        },
        {
          'w-[50%] md:w-[33%] lg:w-[50%]': isHalf,
        },
      )}
    >
      <div
        className={`${labelClassName} text-gray-500 mt-[30px] mb-[8px]`}
      >
        {label || ''}
      </div>
      <div className={`${valueClassName} ${!lastItem && 'lg:mb-[30px]'} md:mb-0`}>
        {value || defaultValue}
      </div>
    </div>
  );
}
